import { ReduxAction } from 'redux/store';
import { SET_MESSAGE } from "./firebaseMessage.type";
import { FirebaseMessage } from "../../App";

export const setMessage = (input: FirebaseMessage): ReduxAction => {
	return {
		type: SET_MESSAGE,
		payload: input,
	};
};